import { Box, Text, SimpleGrid, Textarea, Checkbox } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { Control } from "react-hook-form";
import Field from "components/Input/Field";
import SelectContato from "components/Input/SelectContato";
import SelectMotivoInadimplencia from "ui/components/Input/SelectMotivoInadimplencia";
import SelectTreeResultadoContato from "components/Input/SelectTreeResultadoContato";
import SelectPessoas from "components/Input/SelectPessoas";
import { UseFormWatch } from "react-hook-form";
import { TipoEntidadeEnum } from "resources/enums/conta";

interface FormNovaCobrancaProps {
  control: Control<any>;
  tenantId: string;
  pessoaId?: string;
  unidadeId?: string;
  isEdit?: boolean;
  watch: UseFormWatch<any>;
}

function FormNovaCobranca({
  control,
  tenantId,
  unidadeId,
  watch,
}: FormNovaCobrancaProps) {
  const isChecked = watch("checkboxNovoContato");

  return (
    <>
      <Box as={Row} gutter={16}>
        <Col md={6}>
          <Field
            label="Contato Realizado"
            control={control}
            name="data"
            rules={{ required: "Campo obrigatório" }}
            inputProps={{
              type: "date",
            }}
          />
        </Col>

        <Col md={6}>
          <Field
            label="Hora"
            control={control}
            name="hora"
            rules={{ required: "Campo obrigatório" }}
            inputProps={{ type: "time" }}
          />
        </Col>

        <Col md={12}>
          <Field
            label="Responsável"
            name="pessoaResponsavelId"
            control={control}
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectPessoas
                showSearch
                unidadeId={unidadeId}
                tenantId={tenantId}
                isInvalid={isInvalid}
                tipoEntidades={[TipoEntidadeEnum.Condomino]}
                {...field}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        </Col>
      </Box>

      <Box as={Row} gutter={16} mt={4}>
        <Col md={6}>
          <Field
            label="Resultado contato"
            control={control}
            name="resultadoCobrancaId"
            rules={{ required: "Campo obrigatório" }}
            render={({ field }) => <SelectTreeResultadoContato {...field} />}
          />
        </Col>

        <Col md={6}>
          <Field
            label="Meio de comunicação"
            control={control}
            name="tipoContatoId"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectContato isInvalid={isInvalid} {...field} />
            )}
          />
        </Col>

        <Col md={12}>
          <Field
            label="Motivo inadimplência"
            control={control}
            name="motivoInadimplenciaId"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectMotivoInadimplencia isInvalid={isInvalid} {...field} />
            )}
          />
        </Col>
      </Box>

      <Box as={Row} mt={4}>
        <Col flex={1}>
          <Field
            label="Anotações"
            control={control}
            shouldUnregister
            name="observacao"
            render={({ field, isInvalid }) => (
              <Textarea
                isInvalid={isInvalid}
                className="chakra-input"
                rows={6}
                {...field}
              />
            )}
          />
        </Col>
      </Box>

      <Box mb="16px" mt={8}>
        <Row gutter={32}>
          <Col flex={1}>
            <Field
              control={control}
              name="checkboxNovoContato"
              render={({ field, isInvalid }) => (
                <Checkbox
                  isChecked={!!field.value}
                  onChange={() => {
                    field.onChange(!field.value);
                  }}
                  isInvalid={isInvalid}
                >
                  <Text fontSize={14}>Agendar novo contato</Text>
                </Checkbox>
              )}
            />
          </Col>
        </Row>
      </Box>

      {isChecked && (
        <SimpleGrid gap={39} columns={2}>
          <Box flex={1}>
            <Box as={Row} gutter={32}>
              <Col md={14}>
                <Field
                  shouldUnregister
                  label="Data"
                  rules={{
                    required: true,
                  }}
                  control={control}
                  name="dataAgendamento"
                  inputProps={{
                    type: "date",
                  }}
                />
              </Col>

              <Col md={10}>
                <Field
                  shouldUnregister
                  label="Hora"
                  rules={{
                    required: true,
                  }}
                  control={control}
                  name="horaAgendamento"
                  inputProps={{ type: "time" }}
                />
              </Col>
            </Box>
          </Box>

          <Box as={Row}>
            <Col flex={1}>
              <Field
                shouldUnregister
                label="Responsável Agendamento"
                name="pessoaResponsavelAgendamento"
                rules={{
                  required: true,
                }}
                control={control}
                render={({ field, isInvalid }) => (
                  <SelectPessoas
                    showSearch
                    tenantId={tenantId}
                    isInvalid={isInvalid}
                    tipoEntidades={[TipoEntidadeEnum.Condomino]}
                    {...field}
                    unidadeId={unidadeId}
                    value={field.value}
                    onChange={field.onChange}
                  />
                )}
              />
            </Col>
          </Box>
        </SimpleGrid>
      )}
    </>
  );
}

export default FormNovaCobranca;
